import ApiClient from "../helpers/ApiClient";

export const getPartnersData = async () => {
    try {
        const response = await ApiClient.get(`/researchandstudentlife/getPartner`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const addPartnersData = async ({ partner_name, url, file }) => {
    try {
        const response = await ApiClient.post(`/researchandstudentlife/addPartner`,
            { partner_name, url, file },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const editPartnersData = async ({ id, partner_name, url, file }) => {

    try {
        const response = await ApiClient.put(`/researchandstudentlife/updatePartner/${id}`,
            { partner_name, url, file },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const deletePartnerData = async ({ id }) => {
    try {
        const response = await ApiClient.delete(`/researchandstudentlife/deletePartner/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const addPartnersDocs = async ( formData ) => {
    try {
        const response = await ApiClient.post(`/researchandstudentlife/addTrainingPartnerDocs`,
            formData ,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getPartnersDocData = async () => {
    try {
        const response = await ApiClient.get(`/researchandstudentlife/getTrainingpartnerDocs`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const deletePartnerDocData = async ({ id }) => {
    try {
        const response = await ApiClient.delete(`/researchandstudentlife/deletePartnerDocs/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}